import M from 'materialize-css'

const MODAL_CLASS = '.modal'

const Modal = () => {
	const init = () => {
		removeOverflowHiddenFromPreviousModals()

		const modalElements: NodeListOf<HTMLElement> = document.querySelectorAll(MODAL_CLASS)

		for (let i = 0; i < modalElements.length; i++) {
			const el = modalElements[i]
			const options: Partial<M.ModalOptions> = {}

			if (el.dataset.dismissible === 'false') {
				options.dismissible = false
			}

			const instance = M.Modal.init(el, options)

			if (el.classList.contains('open')) {
				instance.open()
			}
		}
	}

	const removeOverflowHiddenFromPreviousModals = () => {
		document.body.style.overflow = 'auto'
	}

	return {
		init,
	}
}

export default Modal
